import PropTypes from 'prop-types';
import React, { useState, useLayoutEffect } from 'react';
import { connect } from 'react-redux';

import { signedOutErrorSelector, applicationIdSelector } from '../../reducers/selectors';
import ConfirmationModal from '../sections/provisional-offer-options/ConfirmationModal';

const { REACT_APP_ACCOUNTS_BASE_URL: ACCOUNTS_URL } = process.env;
const { REACT_APP_CLIENT_ROOT: NISO_ROOT } = process.env;
const { REACT_APP_PLATFORM_DASHBOARD: PLATFORM_STUDENT_DASHBOARD } = process.env;

export const SignedOutErrorModal = ({ signedOutError, applicationId }) => {
  const [showModal, setModal] = useState(false);

  useLayoutEffect(() => {
    setModal(signedOutError);
  }, [signedOutError]);

  const attemptReconnect = () => {
    setModal(false);
    if (!applicationId) window.location.href = `${PLATFORM_STUDENT_DASHBOARD}`;
    else window.location.href = `${ACCOUNTS_URL}/customers/sign-in?returnTo=${NISO_ROOT}`;
  };

  return (
    <ConfirmationModal
      isOpen={showModal}
      title="Oh no! Looks like you've been signed out."
      content="Don't worry, we've saved your application, and you can sign in again to keep going."
      confirmText="Sign in"
      cancelText="Cancel"
      onClose={attemptReconnect}
      onConfirm={attemptReconnect}
    />
  );
};

SignedOutErrorModal.propTypes = {
  signedOutError: PropTypes.bool.isRequired,
  applicationId: PropTypes.string,
};

SignedOutErrorModal.defaultProps = {
  applicationId: '',
};

export const mapStateToProps = state => ({
  signedOutError: signedOutErrorSelector(state),
  applicationId: applicationIdSelector(state),
});

export default connect(mapStateToProps, null)(SignedOutErrorModal);
